import { db } from '@util/firebase';
import { logError } from '@util/logError';
import { arrayUnion, doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { UpdateSearchDocumentArgs } from './search.types';

export const saveSearchQuery = async (args: UpdateSearchDocumentArgs) => {
  if (!args.uid) return null;

  const searchesRef = doc(db, 'user_searches', args.uid);

  const queries = await getDoc(searchesRef);

  try {
    // if query exists, remove it and move it to beginning of the list, else add to the end
    if (queries.data()?.queries.includes(args.query)) {
      const newQueries = queries
        .data()
        ?.queries.filter((q: string) => q !== args.query);
      newQueries.unshift(args.query);
      await updateDoc(searchesRef, {
        queries: newQueries,
      });
    } else {
      await updateDoc(searchesRef, {
        queries: arrayUnion(args.query),
      });
    }
  } catch (error) {
    const msg = (error as Error).message;
    if (msg.includes('No document to update')) {
      await setDoc(searchesRef, {
        queries: [args.query],
      });
    } else {
      logError(error);
    }
  }
};
